import { FC, memo } from 'react'
import Overview from './components/Overview'
import History from './components/History'
import { useAssertUrlList } from '@/hooks/address'
import { Web3WalletItemModel } from '@/services/apis/wallet/models'

interface Web3WalletDetailProps {
  walletKey: string
  wallet: Web3WalletItemModel
}

const Web3WalletDetail: FC<Web3WalletDetailProps> = ({ walletKey, wallet }) => {
  const assertUrls = useAssertUrlList()
  return (
    <>
      <Overview
        walletName={wallet?.accountName}
        address={wallet?.addressList?.[0]?.address}
        assertUrls={assertUrls}
      />
      <History walletKey={walletKey} />
    </>
  )
}

export default memo(Web3WalletDetail)
